import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

type GeologyCrushingTableNoResultsContentProps = {
  isShiftLocked: boolean,
  canToggleLock: boolean
};

const GeologyCrushingTableNoResultsContent: React.FC<GeologyCrushingTableNoResultsContentProps> = ({
  isShiftLocked,
  canToggleLock
}) =>
  <div className="text-center flex flex-col gap-1 py-4">
    <span className="text-sm text-theme-text">No crushing entries during selected shift.</span>
    <div className="flex flex-col items-center justify-center gap-6">
      <div className="h-[2px] w-[20rem] bg-theme-table-border" />
      {!isShiftLocked
        ? <p className="text-base text-theme-text max-w-[45rem]">Add a new one by selecting a <span className="font-bold">loader</span>, <span className="font-bold">movement origin</span>, <span className="font-bold">number of loads</span> and <span className="font-bold">destination</span> above.</p>
        : canToggleLock
          ? <p className="text-base text-theme-text max-w-[45rem]">
            The shift is locked. If you need to add a new crushing entry, <span className="font-bold">unlock the shift</span> first on the
            <Link
              className="mx-1 inline-flex items-center gap-1 px-2 font-bold border border-theme-info bg-theme-surface-2 hover:bg-theme-info-hover hover:text-white rounded transition duration-150 ease-in-out text-theme-info"
              to='/'
            >
              Home
              <FontAwesomeIcon className="text-xs" icon={faExternalLinkAlt} />
            </Link>
            page.
          </p>
          : <p className="text-base text-theme-text max-w-[45rem]">The shift is <span className="font-bold">locked</span>.If you need to add a new crushing entry, <span className="font-bold">contact an admin</span>.</p>
      }
    </div>
  </div>

export default GeologyCrushingTableNoResultsContent;